<template>
  <div class="lib-select">
    <label for="LibHeaderSelectNav">Serwisy GUNB:</label>
    <select
      id="LibHeaderSelectNav"
      :style="{ 'background-image': `url(${iconSrc})` }"
      v-model="selected"
    >
      <option
        :value="item.value"
        v-for="item in servicesList"
        :key="item.value"
      >
        {{ item.text }}
      </option>
    </select>
  </div>
</template>
<script>
import { servicesList } from "../data.js";
export default {
  name: "LibHeaderSelectNav",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected: "current",
      servicesList,
    };
  },
  computed: {
    iconSrc() {
      return this.$vuetify.theme.dark
        ? "/img/icon-select.svg"
        : "/img/icon-select.svg";
    },
  },
  watch: {
    selected() {
      console.log(this.selected);
      location = this.selected;
    },
  },
  methods: {},
};
</script>

<style scoped>
.lib-select {
  display: flex;
  align-items: center;
  gap: 10px;

  select {
    appearance: none;
    height: 30px;
    border: 1px solid var(--c-primary-blue);
    border-radius: 6px;
    color: #fff;
    padding: 0 38px 0 10px;
    background: #fff;
    color: var(--c-primary);
    outline: none;
    font-size: 0.875rem;
    font-weight: 500;
    background-repeat: no-repeat;
    background-size: 16px 12px;
    background-position: right 0.75rem center;
    option {
      color: var(--c-primary);
      padding: 2px 10px;
    }
  }
}
</style>
